import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import ServiceItem from './ServiceItem'

const Services = ({ services, enableEdit }) =>
  <Fragment>
    {
      services.map((service = {}, index) =>
        <ServiceItem key={ service.skuId || index } service={ service } enableEdit={ enableEdit } />
      )
    }
  </Fragment>

Services.propTypes = {
  enableEdit: PropTypes.bool,
  services: PropTypes.arrayOf(PropTypes.shape())
}

export default Services
